import { CONTACT_TYPE } from 'Constants/enums';
import { MobXProviderContext } from 'mobx-react';
import { ContactModelBase } from 'Models/ContactModel';
import { ContactModelV2 } from 'Models/ContactModelV2';
import { useCallRouter } from 'Modules/softphone/hooks';
import { useUIStore } from 'Modules/ui/index.store';
import React from 'react';
import { useNavigate } from 'react-router';
import { RootStoreProps } from 'Stores/RootStore.types';

export const useEntityData = () => {
  const navigate = useNavigate();

  const { conversation } = React.useContext(MobXProviderContext) as RootStoreProps;

  const { callWithPerson } = useCallRouter();

  const makeCall = (personId?: string, phone?: string) => {
    void callWithPerson(personId, phone);
  };
  const messageUser = (
    personId: string,
    phoneNumber: string,
    contactType: CONTACT_TYPE
  ) => {
    if (contactType === 'Person') {
      void conversation
        .loadOrCreateConversationWithPost(personId)
        .then((resp) => navigate(`/chat/conversations/${resp.data.id}/menu`));
    } else {
      void conversation
        .loadOrCreateConversationWithPost(null, phoneNumber)
        .then((resp) => navigate(`/chat/conversations/${resp.data.id}/menu`));
    }
  };

  return {
    makeCall,
    messageUser,
  };
};

export type EntityDetails = {
  unsavedContact: ContactModelBase | null;
  person: ContactModelV2 | null;
  contacts: ContactModelV2[] | null;
} | null;

export const useEntityDetails = () => {
  const { person: personStore, contact: contactStore } = React.useContext(
    MobXProviderContext
  ) as RootStoreProps;

  const { entitySidePanelInfo } = useUIStore();

  // Trigger initial loading when entity info changes
  React.useEffect(() => {
    const entityType = entitySidePanelInfo?.entityType;
    const entityId = entitySidePanelInfo?.entityId?.toString();

    if (entityType && entityId && entityType === 'person') {
      void personStore.loadPersonByIdGetIfMissingGet(entityId);
    }
  }, [entitySidePanelInfo, personStore, contactStore]);

  // Get entity details reactively from MobX store
  const getDetails = (): EntityDetails => {
    const entityType = entitySidePanelInfo?.entityType;
    const entityId = entitySidePanelInfo?.entityId?.toString();

    if (!entityType || !entityId) {
      return {
        unsavedContact: null,
        person: null,
        contacts: null,
      };
    }

    if (entityType === 'person') {
      const person = personStore.selectPersonValueById(Number(entityId));
      return { person, unsavedContact: null, contacts: null };
    }

    // For phone numbers, get contacts
    const extrContactsPbo = personStore.getAllContactsWithSameNum(entityId);
    const extrContacts =
      extrContactsPbo?.state === 'fulfilled' ? extrContactsPbo.value : null;

    if (extrContacts && extrContacts.length) {
      return {
        contacts: extrContacts,
        unsavedContact: null,
        person: null,
      };
    }

    // Get unsaved contact
    const contactPbo = contactStore.loadContactByPhoneNumber(entityId);
    const unsavedContact =
      contactPbo?.state === 'fulfilled' ? contactPbo.value : null;

    return {
      unsavedContact,
      person: null,
      contacts: null,
    };
  };

  return {
    getDetails,
  };
};
